module.exports = __webpack_public_path__ + "static/media/instruction_thigh.02e656ef.webp";